// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__lGs+6","closeButton":"Panel_closeButton__UXH+N","cardsContainer":"Panel_cardsContainer__Pz7CT"};